// extracted by mini-css-extract-plugin
module.exports = {"container":"Tooltip_container__3zmyk","top":"Tooltip_top__Yg7GR","bottom":"Tooltip_bottom__2nMrF","content":"Tooltip_content__3-53k","large":"Tooltip_large__3mtIP"};